<template>
  <div
    class="ndsText"
    :class="getClasses"
  >
    <slot />
  </div>
</template>

<script setup lang="ts">
import { type PropType, computed } from 'vue'
import { NdsTextSizes } from '@/components/NewDesignSystem/NdsText/NdsText.interfaces'
const props = defineProps({
  size: {
    type: String as PropType<NdsTextSizes>,
    default: NdsTextSizes.M,
  },
  emphasis: {
    type: Boolean,
    default: false,
  },
})

const getClasses = computed(() => {
  let classes = `-${props.size}`

  if (props.emphasis) {
    classes = classes + ' -emphasis'
  }

  return classes
})
</script>

<style lang="scss" scoped>
.ndsText {
  font-weight: 400;
  line-height: 170%;
  color: #333;
  font-style: normal;
  margin: 0;
  -webkit-font-smoothing: antialiased;

  &.-small {
    font-size: 12px;
  }

  &.-medium {
    font-size: 14px;
  }

  &.-large {
    font-size: 16px;
  }

  &.-emphasis {
    font-weight: 500;
  }
}
</style>
